<template>
     <div class="center">
      <div class="title">
      <section id="monster" class="container">
        <img width="200" src="../../image/111.png" alt="">
        <h2>怪獸血量</h2>
        <div class="healthbar">
          <div class="healthbar__value" :style="monsterStyle"></div>
        </div>
      </section>
      <section id="player" class="container2">
        
        <img width="200" src="../../image/a855df93a36c4a9085c781837083ba9a.png" alt="">
        <h2>你的血量</h2>
        <div class="healthbar">
          <div class="healthbar__value" :style="playerStyle"></div>
        </div>
      </section>
    </div>
      <section class="container4" v-if="winner">
        <h2>Game Over!</h2>
        <h3 v-if="winner === 'draw'">平手</h3>
        <div v-else-if="winner === 'monster'">
          <h3 >怪獸獲勝</h3>
          <img width="200" src="../../image/111.png" alt="">
        </div>
        <div v-else>
          <h3 >玩家獲勝</h3>
           <img width="200" src="../../image/a855df93a36c4a9085c781837083ba9a.png" alt="">
        </div>
        <button @click="reStart">重新開始</button>
      </section>
      <div id="controls" class="button-center">
        <div>
          <button @click="attackMonster">攻擊</button>
        <button :disabled="RoundSpecialAttack" @click="attackSpecial">
          特別攻擊
        </button>
        </div>
        <div>
          <button @click="HealPlayer">治癒</button>
        <button @click="surrender">投降</button>
        </div>
      </div>
      <section id="log" class="container3">
        <h3 class="fight">戰鬥紀錄</h3>
        <ul>
          <li v-for="logMessage in logMessages" :key="logMessage">
            <span
              :class="{'log--玩家':logMessage.actionBy ==='玩家','log--怪獸':logMessage.actionBy ==='怪獸'}"
              >{{logMessage.actionBy === '玩家' ? '玩家':'怪獸'}}</span
            >
            <span v-if="logMessage.actionType ==='治癒'"
              >治癒自己
              <span class="log--治癒">{{ logMessage.actionValue }}滴血</span></span
            >
            <span v-else-if="logMessage.actionType ==='攻擊'">
              全力攻擊
              <span class="log--攻擊">{{ logMessage.actionValue }}滴血</span>
            </span>
            <span v-else>
              特別攻擊
              <span class="log--特別攻擊">{{ logMessage.actionValue }}滴血</span>
            </span>
          </li>
        </ul>
      </section>
    </div>
</template>


<script>
    function getRandomValue(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
    }
export default {
    data() {
    return {
      playerHealth: 100,
      monsterHealth: 100,
      currentRound: 0,
      winner: null,
      logMessages: [],
    };
  },
  watch: {
    playerHealth(value) {
      if (value <= 0 && this.monsterHealth <= 0) {
        this.winner = "draw";
      } else if (value <= 0) {
        this.winner = "monster";
      }
    },
    monsterHealth(value) {
      if (value <= 0 && this.playerHealth <= 0) {
        this.winner = "draw";
      } else if (value <= 0) {
        this.winner = "player";
      }
    },
  },
  computed: {
    monsterStyle() {
      if (this.monsterHealth < 0) {
        return {
          width: "0%",
        };
      }
      return {
        width: this.monsterHealth + "%",
      };
    },
    playerStyle() {
      if (this.playerHealth < 0) {
        return {
          width: "0%",
        };
      }
      return {
        width: this.playerHealth + "%",
      };
    },
    RoundSpecialAttack() {
      return this.currentRound % 3 !== 0;
    },
  },
  methods: {
    attackMonster() {
      this.currentRound++;
      const attackValue = getRandomValue(6, 12);
      this.monsterHealth -= attackValue;
      this.attackPlayer();
      this.addLogMessages("玩家", "攻擊", attackValue);
    },
    attackPlayer() {
      const attackValue = getRandomValue(8, 15);
      this.playerHealth -= attackValue;
      this.addLogMessages("怪獸", "攻擊", attackValue);
    },
    attackSpecial() {
      this.currentRound++;
      const attackValue = getRandomValue(10, 20);
      this.monsterHealth -= attackValue;
      this.attackPlayer();
      this.addLogMessages("玩家", "特別攻擊", attackValue);
    },
    HealPlayer() {
      this.currentRound++;
      const healHealth = getRandomValue(8, 20);
      if (this.playerHealth + healHealth > 100) {
        this.playerHealth = 100;
      } else {
        this.playerHealth += healHealth;
      }
      this.attackPlayer();
      this.addLogMessages("玩家", "治癒", healHealth);
    },
    surrender() {
      this.winner = "monster";
    },
    reStart() {
      this.playerHealth = 100;
      this.monsterHealth = 100;
      this.currentRound = 0;
      this.winner = null;
      this.logMessages = [];
    },
    addLogMessages(who, what, value) {
      this.logMessages.unshift({
        actionBy: who,
        actionType: what,
        actionValue: value,
      });
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}


body {
  margin: 0;
}

.center{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

header {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 0.5rem;
  background-color: #880017;
  color: white;
  text-align: center;
  margin-bottom: 2rem;
}

.title{
  display: flex;
  margin-left: 2rem;
  margin-right: 2rem;
}


.healthbar {
  max-width: 10rem;
  height:25px;
  border-radius: 1rem;
  border: #ff450d 1px solid;
  margin:auto;
  margin-top:1rem;
  margin-bottom: 1rem;
}

.healthbar__value {
  background-color: rgb(236, 95, 52);
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  transition: all 0.5s linear;
}

.container {
  width: 15rem;
  text-align: center;
  padding: 0.5rem;
  margin: 1rem auto;
  border-radius: 0.5rem;
  background-color: rgb(255, 229, 197);
  
}

.container2{
  width: 15rem;
  text-align: center;
  padding: 0.5rem;
  margin: 1rem auto;
  border-radius: 12px;
  margin-left: 2rem;
  background-color: rgb(255, 229, 197);
}
.container3{
  max-width: 65%;
  width: 50rem;
  text-align: center;
  margin: 1rem 0 2rem 0;
  background: rgb(255, 253, 244);
  border-radius: 12px;
  border: 4px solid rgb(255, 229, 197);
}

.container4{
  max-width: 65%;
  width: 50rem;
  text-align: center;
  margin: 1rem 0 2rem 0;
  background: rgb(255, 229, 197);
  border-radius: 12px;
}

#monster h2,
#player h2{
  color: rgb(167, 97, 39);
}

#monster img,
#player img{
  margin-top: 1.5rem;
}

#controls {
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

button {
  font: inherit;
  font-size: 20px ;
  color:rgb(167, 97, 39); 
  border: 3px solid rgb(255, 234, 171);
  box-shadow: 
    0 0 0 3px rgb(253, 164, 62);
  background-color: #ffcf86;
  padding: 1rem 2rem;
  border-radius: 2rem;
  margin: 1rem;
  width: 12rem;
  cursor: pointer;
}

button:focus {
  outline: none;
}

button:hover,
button:active {
  border: 3px solid rgb(255, 234, 171);
  box-shadow: 
    0 0 0 3px rgb(253, 164, 62);
  background-color: #fdba56;
}

button:disabled {
  background-color: #ccc;
  border-color: #ccc;
  box-shadow: none;
  color: #3f3f3f;
  cursor: not-allowed;
}

#log ul {
  list-style: none;
  margin-bottom: 3rem;
  padding: 0;
}

#log li {
  margin: 0.5rem 0;
}

.log--玩家 {
  color: #ff9d00;
}

.log--怪獸 {
  color: #0ca85f;
}

.log--攻擊 {
  color: red;
}

.log--治癒 {
  color: #ffa1d3;
}

.log--特別攻擊{
  color: rgb(15, 0, 128);
}

.fight{
  color: rgb(255, 174, 0);
  font-size: 50px;
  -webkit-text-stroke: 2px rgb(117, 60, 13);
  margin-bottom: -0.2rem;
}

</style>